import React, { useState, useEffect, useMemo } from "react";
import { Card, Table, Col, Form } from "react-bootstrap";
import { apiService } from "service/ApiService";
import { notificationService } from "service/NotificationService";
import IntegrationSelect from "components/DropDowns/IntegrationSelect";
import LinkButton from "views/Components/LinkButton";
import { ClipLoader } from "react-spinners";

import { useTranslation } from "react-i18next";

function IntegrationProductsTable({
  storeId,
  onCheckboxToggle,
  selectedIntegration,
  onSelectIntegration,
  selectedStoreProductId,
  matchedIds,
  allMatchedIds = [],
  onSubmit,
}) {
  const {
    t,
  } = useTranslation();

  const [data, setData] = useState([]);
  const [integrationId, setIntegrationId] = useState(null);
  const [search, setSearch] = useState({ id: "", category: "", name: "", price: "" });
  const [showLoader, setShowLoader] = useState(false);

  const handleSearch = (event, column) => {
    setSearch({ ...search, [column]: event.target.value });
  };

  const filteredData = data.filter((row) => {
    return (
      row.id.toString().startsWith(search.id) &&
      row.category.toLowerCase().includes(search.category.toLowerCase()) &&
      row.name.toLowerCase().includes(search.name.toLowerCase()) &&
      row.price.toString().includes(search.price)
    );
  });

  const handleIntegrationChange = async (value) => {
    setIntegrationId(value);
    onSelectIntegration(value);
    await getData(value);
  };

  const getData = async (value) => {
    setShowLoader(true);
    try {
      if (value == 1) {
        const dataResponse = await apiService.get(`api/v1/products/store/${storeId}/efood`);
        setData(dataResponse);
      } else if (value == 2) {
        const dataResponse = await apiService.get(`api/v1/products/store/${storeId}/wolt`);
        setData(dataResponse);
      } else if (value == 3) {
        const dataResponse = await apiService.get(`api/v1/products/store/${storeId}/box`);
        setData(dataResponse);
      } else if (value == 5) {
        const dataResponse = await apiService.get(`api/v1/products/store/${storeId}/gonnaorder`);
        setData(dataResponse);
      } else if (value == 6) {
        const dataResponse = await apiService.get(`api/v1/products/store/${storeId}/deliverymanager`);
        setData(dataResponse);
      } else if (value == 7) {
        const dataResponse = await apiService.get(`api/v1/products/store/${storeId}/fluter`);
        setData(dataResponse);
      } else if (value == 11) {
        const dataResponse = await apiService.get(`api/v1/products/store/${storeId}/culizen`);
        setData(dataResponse);
      } else if (value == 14) {
        const dataResponse = await apiService.get(`api/v1/products/store/${storeId}/orderoo`);
        setData(dataResponse);
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
      console.error("Error fetching data:", error);
      notificationService.notifyWarn(error.message);
    } finally {
      setShowLoader(false);
    }
  };

  const sortedData = useMemo(() => {
    return [...filteredData].sort((a, b) => {
      const aMatches = /^-?[\d.]+(?:e-?\d+)?$/.test(a.id) ? matchedIds.includes(a.id.toString()) : matchedIds.includes(a.id);
      const bMatches = /^-?[\d.]+(?:e-?\d+)?$/.test(b.id) ? matchedIds.includes(b.id.toString()) : matchedIds.includes(b.id);
      if (aMatches && !bMatches) return -1;
      if (!aMatches && bMatches) return 1;
      return 0;
    });
  }, [filteredData, matchedIds]);

  return (
    <Card className="regular-table-with-color">
      <Card.Header>
        <Card.Title className="row">
          <Col md="6">
            <IntegrationSelect title={t("common.labels.platform")} defaultValue={selectedIntegration} handler={handleIntegrationChange} />
          </Col>
          <Col md="6">
            <LinkButton handler={onSubmit} disabled={!selectedStoreProductId || !selectedIntegration} />
          </Col>
        </Card.Title>
      </Card.Header>
      <Card.Body className="table-responsive">
        {showLoader ? (
          <div style={{ textAlign: "center", marginTop: "5vh", marginBottom: "5vh" }}>
            <ClipLoader size={50} color={"#ff6fbc"} />
          </div>
        ) : (
          <Table className="table-hover" style={{ tableLayout: "fixed" }}>
            <thead>
              <tr>
                <th>
                  ID
                  <Form.Control type="text" placeholder="ID" value={search.id} onChange={(e) => handleSearch(e, "id")} />
                </th>
                <th>{t("tables.headers.category")}<Form.Control type="text" placeholder={t("common.labels.category")} value={search.category} onChange={(e) => handleSearch(e, "category")} />
                </th>
                <th>{t("tables.headers.name")}<Form.Control type="text" placeholder={t("common.labels.name")} value={search.name} onChange={(e) => handleSearch(e, "name")} />
                </th>
                <th>{t("tables.headers.priceEuro")}<Form.Control type="text" placeholder={t("common.labels.price")} value={search.price} onChange={(e) => handleSearch(e, "price")} />
                </th>
                <th className="float-right">{t("tables.headers.matchingAbbreviated")}</th>
              </tr>
            </thead>
            <tbody>
              {sortedData.map((row) => (
                <tr
                  key={row.id}
                  onClick={() => {
                    if (selectedIntegration && selectedStoreProductId) {
                      onCheckboxToggle(row.id);
                    } else return;
                  }}
                  style={selectedIntegration && selectedStoreProductId ? { cursor: "pointer" } : {}}
                >
                  <td>{row.id}</td>
                  <td>{row.category}</td>
                  <td>{row.name}</td>
                  <td>{row.price.toFixed(2)}</td>
                  <td>
                    {!allMatchedIds.includes(row.id.toString()) && <i className="fa fa-times text-danger float-right ml-2"></i>}
                    <input
                      className="float-right"
                      type="checkbox"
                      checked={matchedIds.includes(row.id.toString())}
                      disabled={!selectedIntegration || !selectedStoreProductId}
                      onChange={() => {
                        onCheckboxToggle(row.id);
                      }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Card.Body>
    </Card>
  );
}

export default IntegrationProductsTable;
